
import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
            
          <h1 className="hero-title">
            Des <span className="text-gradient">aventures</span> inoubliables vous attendent
          </h1>
          
          <p className="hero-description">
            Découvrez des destinations extraordinaires, des expériences authentiques 
            et créez des souvenirs qui dureront toute une vie.
          </p>
          
          <div className="hero-actions">
            <button className="btn btn-primary btn-large">
              Explorer les destinations
            </button>
          </div>
          
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">50K+</div>
              <div className="stat-label">Voyageurs satisfaits</div>
            </div>
            <div className="stat">
              <div className="stat-number">100+</div>
              <div className="stat-label">Destinations</div>
            </div>
            <div className="stat">
              <div className="stat-number">15+</div>
              <div className="stat-label">Années d'expérience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;